import * as React from 'react';
import { cn } from '@/lib/utils';

const ScheduleWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-schedule-wrapper', 'rounded-[10px] bg-white p-4 shadow-[0px_4px_10px_rgba(68,43,140,0.05)]', className)}
    {...props}
  />
));
ScheduleWrapper.displayName = 'ScheduleWrapper';

const Schedule = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-schedule', 'relative max-h-[340px] overflow-y-auto text-[14px]', className)}
    {...props}
  />
));
Schedule.displayName = 'Schedule';

const ScheduleItem = React.forwardRef(({ className, disabled, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-schedule-item',
      'relative flex gap-3 pb-5 last:pb-0',
      // Timeline line (before)
      'before:absolute before:bottom-0 before:left-[30px] before:top-0 before:z-0 before:h-full before:w-[1px] before:bg-neutral-lightest',
      disabled && 'pointer-events-none opacity-50',
      className
    )}
    {...props}
  />
));
ScheduleItem.displayName = 'ScheduleItem';

const ScheduleDate = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-schedule-date',
      'relative z-[1] flex flex-shrink-0 items-center justify-center rounded-lg border-[4px] border-solid border-white p-2 font-bold transition-colors',
      variant === 'success' ? 'bg-success text-white' : 'bg-neutral-lightest text-primary',
      className
    )}
    {...props}
  />
));
ScheduleDate.displayName = 'ScheduleDate';

const ScheduleInfos = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-schedule-infos', 'flex-grow border-b border-solid border-bright pb-2', className)}
    {...props}
  />
));
ScheduleInfos.displayName = 'ScheduleInfos';

const ScheduleHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-schedule-header', 'flex items-center gap-3', className)}
    {...props}
  />
));
ScheduleHeader.displayName = 'ScheduleHeader';

const ScheduleTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn('c-schedule-title', 'mb-0 w-0 flex-grow truncate font-bold text-neutral-dark', className)}
    {...props}
  />
));
ScheduleTitle.displayName = 'ScheduleTitle';

const ScheduleHour = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('c-schedule-hour', 'font-light text-neutral', className)}
    {...props}
  />
));
ScheduleHour.displayName = 'ScheduleHour';

export { Schedule, ScheduleWrapper, ScheduleItem, ScheduleDate, ScheduleInfos, ScheduleHeader, ScheduleTitle, ScheduleHour };
